<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let tab;

    const dispatch = createEventDispatcher();

    const onClick = () => {
        dispatch('switch_tab', tab);
        tab.active = true;
    }
</script>

<li class="tab" class:active="{ tab.active }" on:click="{ onClick }">{ tab.title }</li>

<style>
    li {
        display: block;
        float: left;
        font-size: 0.8rem;
        color: #666666;
        background: #e4eaee;
        border: 1px solid var(--default-border-color);
        padding: 10px 15px;
        margin-right: 2px;
        margin-bottom: -1px;
        cursor: pointer;
    }

    li:hover {
        color: #333;
    }

    li.active {
        color: #495057;
        background: #fff;
        border-bottom-color: #fff;
    }

    li:first-child {
        border-top-left-radius: 3px;
    }

    li:last-child {
        border-top-right-radius: 3px;
    }

    @media (max-width: 991px) {
        li {
            width: 33.33333%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: -1px;
        }
    }
</style>